// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  loading: 'Indlæser ændringen…',
  load_failed: 'Jeg kunne ikke indlæse denne ændring.',
  load_retry: 'Prøv igen',
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: 'Dette blev allerede godkendt, så der var ikke mere at gøre.',
  action_failed: 'Det lykkedes ikke, så intet er ændret. Prøv igen om lidt.',
  removed: 'Fjernet',
  retry: 'Prøv igen',
  retry_one: 'Prøv {{name}} igen',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Godkendt.',
    retried: 'Prøvet igen.',
    rejected: 'Afvist.',
  },
  done: {
    summary_one: 'Færdig. {{count}} ændring udført.',
    summary_other: 'Færdig. {{count}} ændringer udført.',
    skipped_one: '{{count}} sprunget over, intet er ændret for den.',
    skipped_other: '{{count}} sprunget over, intet er ændret for dem.',
  },
  partial: {
    summary_one: '{{applied}} af {{approved}} ændringer udført. {{count}} blev ikke udført.',
    summary_other: '{{applied}} af {{approved}} ændringer udført. {{count}} blev ikke udført.',
    detail_one: 'De {{applied}} er gemt. Intet er ændret for de {{count}} nedenfor.',
    detail_other: 'De {{applied}} er gemt. Intet er ændret for de {{count}} nedenfor.',
  },
  stale: {
    summary: '{{applied}} af {{approved}} ændringer udført.',
    detail_one: '{{count}} blev ændret af en anden i mellemtiden.',
    detail_other: '{{count}} blev ændret af en anden i mellemtiden.',
    reason:
      '{{name}} ændrede den til {{value}} kl. {{time}}, før du godkendte, så jeg lod den være. Her er den igen ud fra den nye værdi:',
  },
  undone: {
    summary_one: 'Fortrudt. Den {{count}} ændring er tilbage som før.',
    summary_other: 'Fortrudt. De {{count}} ændringer er tilbage som før.',
    detail: 'Fortrydelsen er også registreret i Amigo-loggen og under Menu → Redigeringshistorik.',
  },
  summary: {
    average: '{{amount}} pr. ret i gennemsnit',
    needs_look: 'Kræver opmærksomhed',
    nothing_else: 'Intet andet ændres',
  },
  labels: {
    waiting: 'Venter på godkendelse',
    skip: 'Spring over',
    unskip: 'Fortryd overspringning',
    approve_all: 'Godkend alle',
    approve_one: 'Godkend {{count}}',
    approve_other: 'Godkend {{count}}',
    approve_row: 'Godkend',
    reject: 'Afvis…',
    reject_confirm: 'Afvis',
    back: 'Tilbage',
    why: {
      amigo: 'Hvorfor ikke? (valgfrit, Amigo læser dette)',
      assistant: 'Hvorfor ikke? (valgfrit, assistenten læser dette)',
    },
    hint: 'Eller svar nedenfor for at ændre noget.',
    show_all_one: 'Vis alle {{count}} ændringer',
    show_all_other: 'Vis alle {{count}} ændringer',
    show_less: 'Vis færre',
    applying_one: 'Udfører {{count}} ændring…',
    applying_other: 'Udfører {{count}} ændringer…',
    rows: {
      skipped: 'Sprunget over',
      applied: 'Udført',
      failed: 'Ikke udført',
      changed: 'Ændret i mellemtiden',
      kept: 'Lad være som den er',
    },
    history: {
      amigo: 'Åbn i Amigo-loggen',
      assistant: 'Åbn i assistentens log',
    },
    undo: 'Fortryd',
    to: 'til',
    from: 'fra',
    rejected: 'Afvist',
    replaced: 'Erstattet',
    expired: 'Udløbet',
  },
};
